import { FC, PropsWithChildren } from 'react';

import { IconButton } from '@sparky';

import { useNetworkShareUrl } from '../hooks/useNetworkShareUrl';
import { useShareParams } from '../ShareOnSocialsContext';
import { ShareParams } from '../types';
import { openNetworkShareDialog } from '../utils';

type Props = {
  label: string;
  networkUrl: string;
  networkParameters: ShareParams;
};

const onShareClick = (networkShareUrl: string) => {
  openNetworkShareDialog(networkShareUrl);
  return false;
};

const ShareButton: FC<PropsWithChildren<Props>> = ({ children, label, networkUrl, networkParameters }) => {
  const { shareParams } = useShareParams();
  const networkShareUrl = useNetworkShareUrl(networkUrl, networkParameters, shareParams);

  return (
    <IconButton
      href={networkShareUrl}
      label={label}
      onClick={event => {
        event.preventDefault();
        onShareClick(networkShareUrl);
      }}
      rel="external nofollow noopener"
      target="_blank">
      {children}
    </IconButton>
  );
};

export default ShareButton;
